
/* START_TEMPLATE */
define('hbs!app/views/templates/clubGuestDirectory',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    return "<!-- UK: incomplete template -->";
},"useData":true});
Handlebars.registerPartial('app/views/templates/clubGuestDirectory', t);
return t;
});
/* END_TEMPLATE */
;
